import { useState } from "react";

export const useModal = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    return {
        modalOpen,
        setModalOpen,
        modalMessage,
        setModalMessage
    }
}